import { component_tool, framework_tool, utils_tool } from '../../../tool'
import React from 'react';
import SetsRoleSelect from './setsRoleSelect';

let { WizModal } = component_tool;
let ref
//配置项
let componentName = 'roleSets'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    dataIndex: "name",
    searchItem: {},
    formItem: {
      maxlength: 20,
      placeholder:"角色组名称不能超过20个字。",
      rules: [{
        required: true,
        message: '请输入角色组名称',
      },
      {
        pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5]{1,20}$/,
        message: '角色组名称不允许使用特殊符号'
      }
    ]
    },
    tableItem: {}
  },

];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        buttonSort:['add','delete'],
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort:['update','subordinateRole','managementRole'],
      rowOperateView: [
        {
          key: "subordinateRole",
          custom: true,
          params: { children: "从属角色" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "从属角色",
                diy: (e) => {
                  return (
                    <SetsRoleSelect
                    key={'roleSetsRole'+e.record.id}
                    action={'roleSetsRole'}
                    {...e}
                    ref={(r) => {
                      ref = r && r.getWrappedInstance()
                    }}
                    />
                   )
                },
                onOk: () => {ref._doRoleAdd()},
                onCancel: () => {
                  ref._doInitParams()
                },
                width: 850
              }
            }
          }
        },
        {
          key: "managementRole",
          custom: true,
          params: { children: "管理角色" },
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                title: "管理角色",
                diy: (e) => {
                  return (
                  <SetsRoleSelect
                  key={'roleManagement'+e.record.id}
                  action={'roleManagement'}
                  {...e}
                  ref={(r) => {
                    ref = r && r.getWrappedInstance()
                  }}
                  />
                  )
                },
                onOk: () => {ref._doRoleAdd()},
                onCancel: () => {
                  ref._doInitParams()
                },
                width: 850
              }
            }
          }
        },

      ],
      commonOperate: {
        add: true,
        update:true,
        delete:true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
    }
  },
  add:{
    path: `${componentName}/addRoleSet`,
    payload: {
      key: `${componentName}@addRoleSet`,
    }
  },
  delete:{
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
    }
  },
  update:{
    path: `${componentName}/updateRoleSet`,
    payload: {
      key: `${componentName}@updateRoleSet`,
    }
  },

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
